import apiClient from './apiClient';

// GET /v2/node-types (serverless-portfolio-tracker): the node catalogue,
// `{ nodeTypes, categories, unsupported }` (DWLF-370). It is the signal
// builders' palette and the FSM builder's event list. Returns the whole body;
// a body without a `nodeTypes` array throws, so a contract change is an error
// rather than an empty palette.
export const nodeTypesAPI = {
  catalogue: async () => {
    const response = await apiClient.get('/node-types');
    const body = response.data;
    if (!body || !Array.isArray(body.nodeTypes)) {
      throw new Error('GET /node-types: expected { nodeTypes: [...] }');
    }
    return body;
  },
};

export default nodeTypesAPI;
